import { get_procedureSos, get_procedureSosReport } from "../query/procedureSosQueries";
import { post_procedureSos, delete_procedureSos } from "../mutations/procedureSosMutations";
import { useQuery, useMutation } from "@1f/react-sdk";
import { createProcedureSosModel } from "../helpers/modelHelpers";

export const PorcedureSosApi = () => {
    const apiGetProcedureSos = useQuery (
        get_procedureSos,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiGetProcedureSosReport = useQuery(
        get_procedureSosReport,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiPostProcedureSos = useMutation(
        post_procedureSos,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    );
    const apiDeleteProcedureSos = useMutation(
        delete_procedureSos,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    );    

    const GetProcedureSos = async (tenantId,aziendaId) => {
        try {
            let apiGetResponse = await apiGetProcedureSos.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId
            })
            if(apiGetResponse && apiGetResponse.data){
                return createProcedureSosModel(apiGetResponse.data.data.getProceduraSos);
            }
        } catch (error) {
            throw new Error(`Errore durante il recupero della procedura SOS del tenant ${tenantId} e dell'azienda ${aziendaId}: ${error.message}`);
        }
    }
    const GetProcedureSosReport = async (aziendaId, userId, datePrint, isToBeSaved, isAllegato) => {
        try {
            let apiGetReportResponse = await apiGetProcedureSosReport.fetch({
                aziendaId: aziendaId,
                userId: userId,
                datePrint: datePrint,
                isToBeSaved: isToBeSaved,
                isAllegato: isAllegato
            })
            if(apiGetReportResponse && apiGetReportResponse.data){
                return apiGetReportResponse.data.data.printProceduraSosReport.response.value;
            }
        } catch (error) {
            throw new Error(`Errore durante la creazione del report della procedura SOS dell'azienda ${aziendaId}: ${error.message}`);
        }
    }
    const PostProcedureSos = async (tenantId,aziendaId,procedureSosData) => {
        try {
            let dataToSave = {
                id: procedureSosData ? procedureSosData.id : 0,
                aziendaId: aziendaId,
                nominativoReferenteSos: procedureSosData.nominativoReferenteSos,
                contributoColleghi: procedureSosData.contributoColleghi,
                attivitaStrumentiAnomalie: procedureSosData.attivitaStrumentiAnomalie,
                prioritaAnomalie: procedureSosData.prioritaAnomalie,
                strumentiSelezione: procedureSosData.strumentiSelezione,
                partenariati: procedureSosData.partenariati,
                soggettiEsterni: procedureSosData.soggettiEsterni
            }
            let apiPostResponse = await apiPostProcedureSos.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                dataInput: dataToSave
            });
            if(apiPostResponse && apiPostResponse.data){
                return createProcedureSosModel(apiPostResponse.data.data.postProceduraSos);
            }

        } catch (error) {
            throw new Error(`Errore durante la creazione della procedura SOS del tenant ${tenantId} e dell'azienda ${aziendaId}: ${error.message}`);
        }
    }
    const DeleteProcedureSos = async (tenantId,aziendaId) => {
        try {
            let apiDeleteResponse = await apiDeleteProcedureSos.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId
            });
            if(apiDeleteResponse && apiDeleteResponse.data){
                return apiDeleteResponse.data.data.deleteProceduraSos.success;
            }
        } catch (error) {
            throw new Error(`Errore durante la cancellazione della procedura SOS del tenant ${tenantId} e dell'azienda ${aziendaId}: ${error.message}`);
        }
    }

    return {
        GetProcedureSos,
        GetProcedureSosReport,
        PostProcedureSos,
        DeleteProcedureSos
    }
}